<ng-container *ngIf="order">
  <div class="flex flex-col flex-1" *transloco="let t; prefix: 'shared.checkout'">
    <ng-container *ngIf="Step=='Step1'">
      <!-- STEP 1 -->
      <main class="flex-1 flex flex-col">
        <progress-stepper class="progress-stepper-onboarding" [StepNo]="stepIndex" [Steps]="Steps"></progress-stepper>

        <section class="container max-w-[800px] pb-[108px]">
          <div class="flex flex-col gap-12 mt-[7rem]">
            <div class="text-center">
              <h1 class="h1 text-black mb-4">{{t('headers.stepOne')}}</h1>
              @if (!isExclusiveProductTypeSelected) {
                <p class="text-xl text-gray-900">{{t('infoText.stepOne')}}</p>
              }
            </div>
            <!-- <div class="flex flex-col gap-14 w-full">
              <div class="bg-white py-5 px-6 rounded-medium">
                <h3 class="text-xl text-black mb-4">Τιμολόγηση</h3>
                <div *ngFor="let product of selectedProducts" class="border p-4 rounded-lg text-black mb-4" [ngClass]="{
                                'billing-basic': product?.sku === '0001',
                                'billing-photography': product?.sku === '0006',
                                'billing-exclusive': product?.sku === '0005'
                              }">
                  <button (click)="toggleContent(product?.title || '')"
                    class="flex flex-row items-center justify-between w-full"
                    [ngClass]="{ 'mb-5': isContentDisplayed(product?.title || '') }">
                    {{ product?.title }}
                    <i [ngClass]="{
                                 'icon-chevron-up': !isContentDisplayed(product?.title ?? ''),
                                 'icon-chevron-down': isContentDisplayed(product?.title ?? '')
                               }"></i>
                  </button>
                  <div [innerHtml]="product.benefits" *ngIf="isContentDisplayed(product?.title ?? '')">
                  </div>
                </div>


                <div class="flex flex-col gap-3">
                  <div class="flex flex-row items-center justify-between" *ngFor="let product of selectedProducts">
                    {{getPricingDescription(product.sku ?? '')}}
                    <div class="gap-1:">
                      <span *ngIf="displayDiscount(product)" class="text-gray-500 line-through text-sm opacity-70">
                        {{ product.unitPrice?.toFixed(2)}}€
                      </span>
                      <span class="text-black font-semibold text-xl ml-2">
                        {{ getFinalProductPrice(product?.unitPrice || 0, product?.discount || 0).toFixed(2) }}€
                      </span>
                    </div>
                  </div>

                  <div class="divider-line1"></div>
                  <div class="flex flex-row items-center justify-between ">
                    Σύνολο
                    <div class="flex flex-row items-center justify-end gap-3">
                      <span *ngIf="displayTotalDiscount(selectedProducts)"
                        class="font-normal line-through  text-[#7E8797]">{{getTotalAmount(selectedProducts ??
                        []).toFixed(2)}}€</span>
                      <span class="text-black font-semibold text-xl">{{getTotalAmountWithDiscounts(selectedProducts ??
                        []).toFixed(2)}}€</span>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
<!--             <div class="w-full"> -->
<!--               <h3 class="text-xl text-black mb-4">Τιμολόγηση</h3> -->
<!--               <app-package [selectedProducts]="selectedProducts"></app-package> -->
<!--             </div> -->
            <app-step-buyer-info [oldState]="buyerInfoData" [orderData]="order"
              (formDataEvent)="handleFormData($event)"></app-step-buyer-info>

          </div>
        </section>
      </main>

      <app-navigation-buttons [HideSkip]="true" [HidePrevious]="false" (PreviousButtonClicked)="OpenModalComponent()" (ExitButtonClicked)="OpenModalComponent()"
        (NextButtonClicked)="submitStep1()"></app-navigation-buttons>

    </ng-container>
    <div *ngIf="Step=='Step2' || step2Loaded" [style.display]="Step!='Step2' ? 'none': null" class="flex flex-col flex-1">
      <!-- STEP 2 -->
      <main class="flex-1 flex flex-col">
        <progress-stepper class="progress-stepper-onboarding" [StepNo]="stepIndex+1" [Steps]="Steps"></progress-stepper>

        <section class="container max-w-[800px] pb-[108px]">
          <div class="flex flex-col gap-12 mt-[7rem]">
            <div class="text-center">
              <h1 class="h1 text-black mb-4">{{t('headers.stepTwo')}}</h1>
              <p class="text-xl text-gray-900">{{t('infoText.stepTwo')}}</p>
            </div>

            <app-step-payment-details [orderNumber]="orderNumber"
              (cardDataUpdatedEvent)="handleCardData($event)"></app-step-payment-details>
          </div>
        </section>

      </main>
      <app-navigation-buttons [HideSkip]="true" (ExitButtonClicked)="OpenModalComponent()"
        (PreviousButtonClicked)="Goto('Step1')" (NextButtonClicked)="submitStep2()"></app-navigation-buttons>
    </div>
    <ng-container *ngIf="Step=='Step3'">
      <!-- STEP 3 -->
      <main class="flex-1 flex flex-col">
        <progress-stepper class="progress-stepper-onboarding" [StepNo]="stepIndex+2" [Steps]="Steps"></progress-stepper>
        <section class="container max-w-[800px] pb-[108px]">
          <div class="flex flex-col gap-12 mt-[7rem]">
            <div class="text-center max-w-[800px]">
              <h1 class="h1 text-black mb-4">{{t('headers.stepThree')}}</h1>
              <p class="text-xl text-gray-900">{{t('infoText.stepThree')}}</p>
            </div>
            <div class="w-full">
              <h3 class="text-gray-900 font-semibold mb-4">{{t('listingPreviewHeaders.listingDetails')}}</h3>
              <div class="bg-white p-4 rounded">
                <div class="text-xl text-black mb-6">{{t('listingPreviewHeaders.basicInfo')}}</div>
                <div class="grid md:grid-cols-2 grid-cols-1 gap-x-8 gap-y-3">
                  <div class="border-b border-gray-300 flex flex-row items-start justify-between pb-3">
                    <span class="flex-1 text-gray-800">{{t('listingPreviewHeaders.propertyType')}}</span>
                    <span *transloco="let tc; prefix: ''" class="flex-1 text-black font-semibold"> {{tc('shared.enum.propertyType.' + this.property?.type)}} </span>
                  </div>
                  <div class="border-b border-gray-300 flex flex-row items-start justify-between pb-3">
                    <span class="flex-1 text-gray-800">{{t('listingPreviewHeaders.propertyArea')}}</span>
                    <span class="flex-1 text-black font-semibold"> {{this.property?.propertyArea}} m² </span>
                  </div>

                  <div class="md:border-b-0 border-b border-gray-300 flex flex-row items-start justify-between">
                    <span class="flex-1 text-gray-800">{{t('listingPreviewHeaders.propertyLocation')}}</span>
                    <span class="flex-1 text-black font-semibold">
                      {{this.property?.address?.streetName}} {{this.property?.address?.streetNumber}}
                      {{this.property?.address?.postalCode}}
                    </span>
                  </div>
                  <div class="flex flex-row items-start justify-between">
                    <span class="flex-1 text-gray-800">{{t('listingPreviewHeaders.askedPrice')}}</span>
                    <span class="flex-1 text-black font-semibold">
                      {{(this.property?.price ?? 0) > 0 ? (this.property?.price | number) : '-'}} €
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full">
              <h3 class="text-xl text-black mb-4">{{t('listingPreviewHeaders.productSelection')}}</h3>
              <app-package [selectedProducts]="selectedProducts"></app-package>
            </div>
            @if (order.total != 0 ) {
            <app-step-review [cardData]="cardData" [orderData]="order"></app-step-review>
            }
          </div>
        </section>

      </main>
      <app-navigation-buttons [HideSkip]="true" (ExitButtonClicked)="OpenModalComponent()"
        (PreviousButtonClicked)="Goto(order.total == 0 ?  'Step1' : 'Step2')" (NextButtonClicked)="submitStep3()"
        [CustomNextTitle]="t('titles.orderConfirmation')" [HideNextArrow]="true" [loading]="loading"></app-navigation-buttons>
    </ng-container>
    <ng-container *ngIf="Step=='Step4'">
      <!-- STEP 4 -->
      <main class="flex-1 flex flex-col mt-[5px]">
        <section class="flex-1 flex justify-center items-center container pb-[108px] pt-[72px]">
          <div class="flex flex-col gap-12 flex-1 max-w-[1024px]">
            <div class="text-start">
              <h1 class="h1 font-sm text-black leading-snug" [innerHTML]="t('headers.stepFour')"></h1>
              <p class="max-w-[380px]" [innerHTML]="t('infoText.stepFour')"></p>
            </div>
            <app-step-review [cardData]="cardData" [orderData]="order"></app-step-review>
          </div>
        </section>

      </main>
      <app-navigation-buttons [HideSkip]="true" [HidePrevious]="true" (ExitButtonClicked)="OpenModalComponent()"
        (PreviousButtonClicked)="Goto('Step3')" (NextButtonClicked)="submitStep4()"
        [CustomNextTitle]="t('titles.myRequests')" [HideNextArrow]="true"></app-navigation-buttons>
    </ng-container>
  </div>
</ng-container>
